module.exports = __webpack_public_path__ + "static/media/LK_Close_Light.0d7ed829.svg";